module.exports = __webpack_public_path__ + "static/img/5.b3d15de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/16/eng/5.png
// module id = S6Ae
// module chunks = 0